import React from 'react';
import SPSearchForm from 'components/marketing-activities/activity-list/search-form';
import SPDrawer from 'components/marketing-activities/activity-list/drawer';
import SPList from 'components/marketing-activities/activity-list/table';
import json from './json';


const MarketingActivities: React.FC<any> = () => {
  const { searchFormView, drawerView } = json;
  return (
    <>
      <SPSearchForm data={searchFormView} />
      <SPDrawer data={drawerView} />
      <SPList />
    </>
  )
}

export default MarketingActivities;